
  import Vue from 'vue'
  import Component from 'vue-class-component';
  import StepByStepConfig from '@/StepByStepConfig';
  import VueScrollTo from 'vue-scrollto';
  import date from 'date-and-time';

  @Component({
    components: {
    }
  })
  export default class ThankYouView extends Vue {


  }
